<template>
  <div>
    <!-- banner section Starts -->
    <section class="banner bplus">
      <div class="banner-section">
        <img
          style="max-height: 470px; object-position: center"
          :src="
            company_data.banner_image
              ? company_data.banner_image
              : '../assets/images/homepage/banner-image.png'
          "
          alt="img"
          class="img-fluid banner-section-img"
        />
      </div>
      <div class="container">
        <h1>Get your ergo game on!</h1>
        <div class="first-section onlyforcrousel">
          <carousel
            :margin="30"
            :nav="true"
            :navText="['&lt;', '&gt;']"
            :rewind="false"
            :responsive="{
              0: { items: 1, nav: true },
              768: { items: 2, nav: true },
              1280: { items: 3, nav: true },
              1400: { items: 4 },
            }"
            class="owl-slider"
          >
            <div class="item">
              <div class="custome_card card1 for_wrap">
                <router-link to="/user/ergo_essentials">
                  <img
                    src="../assets/images/b_plus/bplus-home-ee.png"
                    alt="img"
                    class="mb_30"
                  />
                  <p class="card-heading">Are you posture perfect?</p>
                  <h5 class="font_bold font_size_22 mb_14 text_black">
                    Ergo Essentials
                  </h5>
                  <p class="text_balticsea font_size_18">
                    Enjoy perfect posture no matter where you work.
                  </p>
                  <label>5 minute journey</label>
                </router-link>
              </div>
            </div>
            <div class="item">
              <div class="custome_card card1 for_wrap">
                <router-link to="/user/setup_guidelines">
                  <img
                    src="../assets/images/b_plus/bplus-home-sg.png"
                    alt="img"
                    class="mb_30"
                  />
                  <p class="card-heading">Work better</p>
                  <h5 class="font_bold font_size_22 mb_14 text_black">
                    Setup Guidelines
                  </h5>
                  <p class="text_balticsea font_size_18">
                    Optmize your work setup anywhere anytime.
                  </p>
                  <label>5 minute journey</label>
                </router-link>
              </div>
            </div>
            <div class="item" v-if="lab_card_show">
              <div class="custome_card card1 for_wrap">
                <router-link to="/user/work_from_lab">
                  <img
                    src="../assets/images/b_plus/bplus-lab.png"
                    alt="img"
                    class="mb_30"
                  />
                  <p class="card-heading">Conducting Research</p>
                  <h5 class="font_bold font_size_22 mb_14 text_black">
                    Lab Setup
                  </h5>
                  <p class="text_balticsea font_size_18">
                    Work safely and comfortably in the lab.
                  </p>
                  <label>10 minute journey</label>
                </router-link>
              </div>
            </div>
            <div class="item">
              <div class="custome_card card1 for_wrap">
                <router-link to="/user/video_library">
                  <img
                    src="../assets/images/b_plus/bplus-home-sv.png"
                    alt="img"
                    class="mb_30"
                  />
                  <p class="card-heading">Move your body</p>
                  <h5 class="font_bold font_size_22 mb_14 text_black">
                    Stretch Videos
                  </h5>
                  <p class="text_balticsea font_size_18">
                    A flexible body is a happy body. Take a moment to move
                    yours.
                  </p>
                  <label>10 minute journey</label>
                </router-link>
              </div>
            </div>
          </carousel>
        </div>
      </div>
    </section>
    <!-- Banner section Ends -->
    <section class="bplus-text">
      <div class="container p-0">
        <div class="row">
          <div class="col-md-12 p-0">
            <div class="inner-section">
              <p class="mb-3">Claim your comfort.</p>
              <p>Your body will thank you!</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import carousel from "vue-owl-carousel";
export default {
  name: "home",
  components: { carousel },
  data() {
    return {
      company_data: {
        banner_image: require("@/assets/images/homepage/banner-image.png"),
        logo: require("@/assets/images/logo.png"),
        lab_card_show: false,
      },
    };
  },
  beforeMount() {
    let data = this.$store.getters["auth/authUser"];

    if (data.client && data.client.lab_training_status === 1) {
      this.lab_card_show = true;
    } else {
      this.lab_card_show = false;
    }

    this.company_data.banner_image = data.client.banner_image;
  },
  mounted() {
    document.title = "PBErgo - " + this.$router.currentRoute.meta.page_title;
    if (this.$parent?.$refs?.fullpageloader) {
      this.$parent.$refs.fullpageloader.is_full_page_loader = true;
      setTimeout(() => {
        this.$parent.$refs.fullpageloader.is_full_page_loader = false;
      }, 500);
    }
  },
};
</script>
